import script from "./member-main-product.vue?vue&type=script&setup=true&lang=js"
export * from "./member-main-product.vue?vue&type=script&setup=true&lang=js"

import "./member-main-product.vue?vue&type=style&index=0&id=79bf7e73&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79bf7e73"]])

export default __exports__